const INVALID_BANK_ACCOUNT_DETAILS_ERROR =
  'Please provide valid bank account details';
const INVALID_SORT_CODE_ERROR = 'Please provide valid sort code';
const INVALID_BANK_ACCOUNT_ERROR = 'Please provide valid account number';
const BASKET_DATA_MISMATCH_ERROR =
  'Data mismatch. Missing basket data on order submission';
const BANK_ACCOUNT_DETAILS_PROCESSING_ERROR =
  'Bank account details could not be processed';

const EMAIL_INVALID_ERROR = 'Email is not valid';
const EMAIL_EXISTS_ERROR = 'Email is already registered with an account';

const BUNDLE_DISCOUNT = 'BUNDLE_DISCOUNT';

export {
  INVALID_BANK_ACCOUNT_DETAILS_ERROR,
  BASKET_DATA_MISMATCH_ERROR,
  BANK_ACCOUNT_DETAILS_PROCESSING_ERROR,
  INVALID_SORT_CODE_ERROR,
  INVALID_BANK_ACCOUNT_ERROR,
  EMAIL_INVALID_ERROR,
  EMAIL_EXISTS_ERROR,
  BUNDLE_DISCOUNT,
};
